module.exports = __webpack_public_path__ + "media/icons/okres-waznosci-99c16d71.svg";